const ONBOARDING_INIT_LOCAL_STORAGE = 'onboardingInit',
  REFRESH_TOKEN_PROPS = {
    isGil: true,
    domain: window.location?.hostname?.includes('localhost') ? '' : '.openbankpay.com',
  },
  REDIRECTION_FORCED = 'redirection-forced',
  INTENTIONAL_NAVIGATION = 'intentional_navigation',
  INTENTIONAL_NAVIGATION_OFF = 'false',
  INTENTIONAL_NAVIGATION_ON = 'true';

export {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
  INTENTIONAL_NAVIGATION_ON,
  ONBOARDING_INIT_LOCAL_STORAGE,
  REDIRECTION_FORCED,
  REFRESH_TOKEN_PROPS,
};
